import { Settings } from 'luxon';

function initialize(config) {
    Settings.defaultZone = config.intl.timezone;
}

export { initialize as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5pdGlhbGl6ZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2luaXRpYWxpemUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2V0dGluZ3MsIFpvbmUgfSBmcm9tICdsdXhvbic7XG5cbnR5cGUgQ29uZmlnID0ge1xuICBpbnRsOiB7XG4gICAgdGltZXpvbmU6IHN0cmluZyB8IFpvbmU7XG4gIH07XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBpbml0aWFsaXplKGNvbmZpZzogQ29uZmlnKSB7XG4gIFNldHRpbmdzLmRlZmF1bHRab25lID0gY29uZmlnLmludGwudGltZXpvbmU7XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFRd0IsU0FBQSxVQUFVLENBQUMsTUFBYyxFQUFBO0lBQy9DLFFBQVEsQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUM7QUFDOUM7Ozs7In0=
